import type { ComponentMultiStyleConfig } from '@chakra-ui/theme'

const Table: ComponentMultiStyleConfig = {
  parts: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'tfoot', 'caption'],
  baseStyle: {
    table: {
      border: '1px solid #E2E8F0',
      borderCollapse: 'separate',
      borderSpacing: 0,
      borderRadius: '13px',
      thead: {
        tr: {
          th: {
            paddingTop: '4',
            paddingBottom: '4',
          },
        },
      },
    },
  },
  variants: {
    simple: {
      table: {
        tbody: {
          tr: {
            _last: {
              td: {
                borderBottomColor: 'transparent',
              },
            },
          },
        },
      },
    },
    striped: {
      table: {
        tbody: {
          tr: {
            _last: {
              td: {
                _first: {
                  borderBottomLeftRadius: '3',
                },
                _last: {
                  borderBottomRightRadius: '3',
                },
              },
            },
          },
        },
      },
    },
  },
  defaultProps: {},
}

export default Table
